import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
// WHY: a joining page appends after the husk dialog that hosts it, so a run's pages are not contiguous — gather by run id and keep the group where the run started.
export function groupOverlayEntries(entries) {
    const groups = [];
    const runIndex = new Map();
    entries.forEach((entry)=>{
        if (entry.presentation !== 'sheet' || entry.sheetRunId == null) {
            groups.push({
                kind: 'dialog',
                key: entry.id,
                entry
            });
            return;
        }
        const existing = runIndex.get(entry.sheetRunId);
        if (existing == null) {
            runIndex.set(entry.sheetRunId, groups.length);
            groups.push({
                kind: 'sheet',
                key: entry.sheetRunId,
                entries: [
                    entry
                ]
            });
            return;
        }
        const group = groups[existing];
        groups[existing] = _object_spread_props(_object_spread({}, group), {
            entries: group.entries.concat(entry)
        });
    });
    return groups;
}
